import glonav from "./partials/_glonav.js"
// import topEvents from "./partials/_top-events.js"
// import topPhotoSwipe from './partials/_top-photoswipe.js';

(function () {

  // ナビゲーション
  if (document.querySelector('#header-nav-btn')) {
    glonav()
  }
  // TOP splide
  // if (document.querySelector('#top-events')) {
  //   topEvents()
  // }

  // TOP splide
  // if (document.querySelector('#top-graduates')) {
  //   // topGraduates()
  // }


}())